export class ScheduleEntry {
    id: number;
    weekday: number;
    hour: number;
    showBlockId: number;
}
